import { useEffect } from "react";
import useNotifications from "./useNotifications";
import {
  notificationService,
  GlobalNotification,
} from "../services/notificationService";

/**
 * Hook that bridges the global notification service with the React notification system
 * This should be used in a high-level component (like App) to listen for global notifications
 */
export const useGlobalNotifications = () => {
  const { setNotification } = useNotifications();

  useEffect(() => {
    // Subscribe to global notifications
    const unsubscribe = notificationService.subscribe(
      (notification: GlobalNotification) => {
        setNotification(notification);
      },
    );

    // Cleanup subscription on unmount
    return unsubscribe;
  }, [setNotification]);
};

export default useGlobalNotifications;
